export default "__VITE_ASSET__Q_dPFXML__"